import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { UserProfileRoutingModule } from './user-profile-routing.module'
import { SharedProfileModule } from '@app/shared-profile/shared-profile.module'
import { UserActionsModule } from '@app/user-actions/user-actions.module'
import { AvailabilityComponent } from './components/availability/availability.component'
import { SharedModule } from '@app/shared/shared.module'
import { NgScrollbarModule } from 'ngx-scrollbar'

import { SharedAvailabilityListModule } from '@app/shared-availability-list/shared-availability-list.module'

@NgModule({
    declarations: [AvailabilityComponent],
    imports: [
        CommonModule,
        SharedProfileModule,
        SharedModule,
        UserProfileRoutingModule,
        UserActionsModule,
        SharedAvailabilityListModule,
        NgScrollbarModule,
    ],
})
export class UserProfileModule {}
